import {Component, OnChanges, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ObjectPageComponent} from 'features/core/shared/object/mvs-object-page-component/object-page.component';
import {MvsCoreService} from 'features/core/shared/service/mvs-core.service';
import {PageHeaderConfig} from 'features/core/shared/service/page/page-header-config.interface';

/**
* Object-Page for cn.CommissionModel (FR-8).
*
* CommissionModel is a Complex Configuration Entity (Rule + Assignment + LogicHook children),
* so it is edited on a dedicated Object-Page via an ObjectComponent — never inline (CONFIG-003).
*
* Header runs in Template-Mode (model name + status badge from CommissionModelStatus.uiColor).
* getPageHeaderConfig() returns null until objectIdentifier?.objectId is set (null-guard),
* so the header only renders once the model is resolved.
*
* NOTE (architecture shell): the hosted CnCommissionModelObjectComponent and the header's
* status-badge data binding are provided by the Component Specialist (FE-T4). This file is the
* routed page shell that resolves the object identifier and exposes the header template slot.
*/
@Component({
    selector: 'mvs-cn-commission-model-object-page',
    templateUrl: './cn-commission-model-object.page.html',
    styleUrls: ['./cn-commission-model-object.page.scss'],
    standalone: false
})
export class CnCommissionModelObjectPage
    extends ObjectPageComponent
    implements OnInit, OnDestroy, OnChanges {

    defaultLabel: string = 'Provisionsmodell';

    constructor(
        protected override route: ActivatedRoute,
        protected override coreService: MvsCoreService
    ) {
        super(route, coreService);
    }

    override ngOnInit(): void {
        this.defaultLabel = 'Provisionsmodell';
        super.ngOnInit();
    }

    protected override getObjectType(): string {
        return 'cn.CommissionModel';
    }

    // headerTemplate is inherited from PageComponent — do NOT redeclare.

    getPageHeaderConfig(): PageHeaderConfig {
        // Null-guard: render the header only once the model is resolved.
        if (!this.objectIdentifier?.objectId) {
            return null;
        }
        return {
            templateRef: this.headerTemplate,
            sticky: true
        };
    }
}
